module.exports = __webpack_public_path__ + "static/media/eye-close.4ba25e59.svg";